import React from "react";
import { Modal, Tabs } from "antd";

import TransactionReceiptExcelUpload from "./TransactionReceiptExcelUpload";
import ManualTransactionReceiptForm from "./ManualTransactionReceiptForm";
import { useTranslation } from "../../i18n/LanguageProvider";

/**
 * Add dialog of the Гүйлгээний Баримт module.
 *
 * Both ways of adding data live in the one module page, so the sidebar keeps a single entry.
 * Only the MANAGE roles can open it, and the backend enforces the same rule.
 */
function TransactionReceiptAddModal({ open, onClose, onSaved }) {
    const { t } = useTranslation();

    const handleSaved = () => {
        onSaved?.();
        onClose?.();
    };

    const items = [
        {
            key: "excel",
            label: t("add.tab.excel"),
            children: <TransactionReceiptExcelUpload onImportSuccess={handleSaved} />,
        },
        {
            key: "manual",
            label: t("add.tab.manual"),
            children: <ManualTransactionReceiptForm onSaved={handleSaved} />,
        },
    ];

    return (
        <Modal
            title={t("receipt.add.modalTitle")}
            open={open}
            onCancel={onClose}
            width={1080}
            footer={null}
            destroyOnClose
        >
            <Tabs defaultActiveKey="excel" items={items} />
        </Modal>
    );
}

export default TransactionReceiptAddModal;
